// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/visual-separation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/visual-separation/visual-separation.js';

mount([g0]);
